import styled, { css } from 'styled-components';
import { useElementVisibilityContext } from 'LayoutBuilderUI/context/ElementVisibilityContext';
import HiddenElementIndicator from 'LayoutBuilderUI/components/overlays/HiddenElementIndicator';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Filter = styled.div.withConfig({
  displayName: "GrayScaleWhenHidden__Filter"
})(({
  enabled = false
}) => {
  if (enabled) {
    return css(["filter:grayscale(1) opacity(20%) blur(1px);"]);
  }
});
function GrayScaleWhenHidden({
  children,
  showIcon = false
}) {
  const {
    isHidden,
    isParentHidden
  } = useElementVisibilityContext();
  const showHideIcon = showIcon && isHidden && !isParentHidden;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Filter, {
      "data-test-id": "grayscale-filter",
      enabled: isHidden,
      children: children
    }), showHideIcon && /*#__PURE__*/_jsx(HiddenElementIndicator, {
      variant: "icon"
    })]
  });
}
export default GrayScaleWhenHidden;